import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "../../components/PageShell";
import { mpGraphSearchSchema } from "./lib";
import { MpGraphsScreen } from "./MpGraphsScreen";

// The page's route. Discovered by vite.config.ts because it sits in a page
// folder; PageShell applies the page's flag gate and header.
function MpGraphsRoute() {
  return (
    <PageShell>
      <MpGraphsScreen />
    </PageShell>
  );
}

export const Route = createFileRoute("/_app/mp-graphs")({
  validateSearch: (search) => mpGraphSearchSchema.parse(search),
  component: MpGraphsRoute,
});
